import Info from '../Help/Info.vue';
import Achievement from './Achievement.vue';
export default {
    components: { Achievement, Info },
    props: {
        achievements: { type: Array, default: null },
        noModal: { type: Boolean, default: false },
        emptyTextKey: { type: String, default: 'achievements.noneInThisRegion' },
    },
    computed: {
        regionGroups() {
            if (!this.achievements)
                return [];
            const achievementGroups = Object.values(Object.groupBy(this.achievements, achievement => achievement.id));
            return Object.values(Object.groupBy(achievementGroups, group => group[0].regionId));
        },
    },
};
